<template>
  <SrpDetailsSummary class="how-it-works-wrap" :isOpened="props.isOpened">
    <template #heading>
      <h2 class="global-h2">
        <span><span>How Custom Collabs Work</span></span>
      </h2>
    </template>
    <template #details>
      <div style="margin-bottom: 18px; border-bottom: 1px rgba(0, 0, 0, 0.15) solid"></div>

      <!-- "How it works" -->
      <div class="how-it-works">
        <HowItWorksText />
      </div>
      <!-- / "How it works" -->
    </template>
  </SrpDetailsSummary>
</template>

<script setup lang="ts">
// Components
import SrpDetailsSummary from "@components/ui/SrpDetailsSummary.vue";
import SrpButton from "@components/ui/SrpButton.vue";
import NoteWithIcon from "@components/NoteWithIcon.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import HowItWorksText from "@views/CustomCollabs/CustomerCustomCollabDetails/HowItWorksText.vue";

const props = withDefaults(
  defineProps<{
    isOpened?: boolean;
  }>(),
  {
    isOpened: true,
  }
);
</script>

<style scoped lang="scss">
@import "@/scss/screen-size-ranges.scss";
@import "@/scss/variables.scss";

// "How it works" ==============================================================
.how-it-works {
  &__ol-list {
    margin-bottom: 20px;
  }
}

// "How it works" wrap =========================================================
.how-it-works-wrap {
  padding: 20px 25px 24px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 3px 15px -5px rgba(0, 0, 0, 0.4);
}
</style>
